export default __webpack_public_path__ + "static/media/readingIcon.58909c15.svg";